(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function normalize(value) {
    return String(value == null ? '' : value).trim();
  }

  function getVariants(variantSelects) {
    var script = variantSelects.querySelector('script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent || '[]'); } catch (e) { return []; }
  }

  function getInputs(variantSelects) {
    return Array.prototype.slice.call(variantSelects.querySelectorAll('.product-form__input')).filter(function (group) {
      return !group.classList.contains('hidden');
    });
  }

  function getSelectedOptions(variantSelects) {
    return getInputs(variantSelects).map(function (group) {
      var typeNode = group.querySelector('.product-form__input__type');
      var type = typeNode && typeNode.dataset ? typeNode.dataset.type : '';
      var select = group.querySelector('select');
      var checked = group.querySelector('input[type="radio"]:checked, input:checked');
      if ((type === 'dropdown' || type === 'quantity-breaks') && select) return normalize(select.value);
      if (checked) return normalize(checked.value);
      if (select) return normalize(select.value);
      return '';
    }).filter(Boolean);
  }

  function findVariant(variants, selectedOptions) {
    if (!variants.length || !selectedOptions.length) return null;
    return variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selectedOptions.length) return false;
      return variant.options.every(function (option, index) {
        return normalize(option) === normalize(selectedOptions[index]);
      });
    }) || null;
  }

  function findForms(sectionId) {
    var forms = [];
    ['#product-form-' + sectionId, '#product-form-installment-' + sectionId].forEach(function (selector) {
      var form = document.querySelector(selector);
      if (form && forms.indexOf(form) === -1) forms.push(form);
    });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (forms.indexOf(form) === -1) forms.push(form);
    });
    return forms;
  }

  function getButtons(form, sectionId) {
    var buttons = [];
    form.querySelectorAll('button[name="add"], button[type="submit"], input[type="submit"]').forEach(function (button) {
      if (buttons.indexOf(button) === -1) buttons.push(button);
    });
    document.querySelectorAll('#ProductSubmitButton-' + sectionId + ', .main-product-atc, .main-atc-button, .main-atc, .shopify-payment-button__button').forEach(function (button) {
      if (button && buttons.indexOf(button) === -1) buttons.push(button);
    });
    return buttons;
  }

  function buttonLabel(button) {
    return button.querySelector('.main-atc__label__text, .main-atc__label, span') || button;
  }

  function setButtonState(form, sectionId, enabled, text) {
    getButtons(form, sectionId).forEach(function (button) {
      if (!button) return;
      if (enabled) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
        button.classList.remove('disabled');
        button.style.pointerEvents = '';
        button.style.opacity = '';
        button.style.cursor = '';
      } else {
        button.disabled = true;
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('disabled');
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.55';
        button.style.cursor = 'not-allowed';
      }
      var label = buttonLabel(button);
      if (label && text) {
        if (button.tagName === 'INPUT') button.value = text;
        else label.textContent = text;
      }
    });
  }

  function setVariantId(form, variant) {
    var input = form.querySelector('input[name="id"], select[name="id"], .product-variant-id');
    if (!input) return;
    input.value = variant ? variant.id : '';
    input.setAttribute('value', variant ? variant.id : '');
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function apply(variantSelects) {
    variantSelects.dataset.skipNonExistent = 'false';
    variantSelects.skipNonExistent = false;

    var sectionId = variantSelects.dataset.section;
    var variants = getVariants(variantSelects);
    var selectedOptions = getSelectedOptions(variantSelects);
    var matchedVariant = findVariant(variants, selectedOptions);
    var available = !!(matchedVariant && matchedVariant.available);
    var message = matchedVariant ? 'Sold out' : 'Unavailable';

    findForms(sectionId).forEach(function (form) {
      if (available) {
        setVariantId(form, matchedVariant);
        setButtonState(form, sectionId, true, 'Add to cart');
        form.removeAttribute('data-hs-invalid-variant');
      } else {
        setVariantId(form, null);
        setButtonState(form, sectionId, false, message);
        form.setAttribute('data-hs-invalid-variant', 'true');
      }
    });

    return available;
  }

  function initOne(variantSelects) {
    if (!variantSelects || variantSelects.dataset.hsVariantFixed === 'true') return;
    variantSelects.dataset.hsVariantFixed = 'true';
    variantSelects.dataset.skipNonExistent = 'false';
    variantSelects.skipNonExistent = false;

    ['change', 'click', 'input'].forEach(function (eventName) {
      variantSelects.addEventListener(eventName, function () {
        setTimeout(function () { apply(variantSelects); }, 0);
        setTimeout(function () { apply(variantSelects); }, 120);
      }, true);
    });

    findForms(variantSelects.dataset.section).forEach(function (form) {
      if (form.dataset.hsSubmitGuard === 'true') return;
      form.dataset.hsSubmitGuard = 'true';
      form.addEventListener('submit', function (event) {
        var ok = apply(variantSelects);
        if (!ok) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          alert('This color is not available in the selected size.');
          return false;
        }
      }, true);
    });

    setTimeout(function () { apply(variantSelects); }, 250);
  }

  function initAll() {
    document.querySelectorAll('variant-selects').forEach(initOne);
  }

  ready(function () {
    initAll();
    document.addEventListener('variantChange', initAll);
    document.addEventListener('shopify:section:load', initAll);
    new MutationObserver(function () { initAll(); }).observe(document.documentElement, { childList: true, subtree: true });
  });
})();
